export const cleanParams = (params: Record<string, any>) => {
    const clean: Record<string, any> = {};
    Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
        clean[key] = value;
    }
    });
    return clean;
};